import { RootState } from 'src/store/store';

export const selectKPIAnswers = (state: RootState) => state.gop?.reportKPI?.answers || [];
export const selectKPIStatuses = (state: RootState) => state.gop?.reportKPI?.statuses || [];
export const selectKPILoading = (state: RootState) => state.gop?.reportKPI?.loading || false;
export const selectKPIError = (state: RootState) => state.gop?.reportKPI?.error || null;
export const selectKPIChartData = (state: RootState) => state.gop?.reportKPI?.chartData || { kpiPlan: [], kpiFact: [] };
export const selectKPIChartLoading = (state: RootState) => state.gop?.reportKPI?.chartLoading || false;
export const selectKPIChartError = (state: RootState) => state.gop?.reportKPI?.chartError || null;
